import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { Popover } from 'antd';
import EditorLink from 'lowcode/components/EditorLink';
import { getIsLogin } from 'lowcode/utils/getIsLogin';
import Icon1 from './Icon1';
import Icon2 from './Icon2';
import Icon3 from './Icon3';
import Icon4 from './Icon4';
import Icon5 from './Icon5';
import QuesIcon from './QuesIcon';
import styled from './index.module.scss';
import SignupPopup from '@/components/Popups/SignupPopupJP';
import { signupCookie } from '@/utils/cookies/signupCookie';

interface IProps {
    type?: string;
}

const WEB_HOST = process.env.NEXT_PUBLIC_WEB_HOST;

const HowGet: FC<IProps> = ({}) => {
    const [isLogin, setIsLogin] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);

    const loginUrl = `${WEB_HOST}/jp/login?redirect=/jp/members-day`;
    const registerUrl = `${WEB_HOST}/jp/register?redirect=/jp/members-day`;
    const list_name = '2024年、エコポイントプログラムがさらに バージョンアップ！最高の特典をお届けします';

    const list = [
        {
            icon: <Icon1 />,
            title: '新規会員登録',
            subtitle: '新規会員登録すると500ポイント獲得！さらに、4月8日（月）～4月14日（日）の間に新規登録したお客様に、追加500ポイントをプレゼント！',
            desc: '※ 新規会員登録の500ポイントは、登録後すぐにお客様のアカウントに付与されます。\n※ 追加の500ポイントは4月23日（火）までにお客様のアカウントに付与されます。',
            linkText: '会員登録はこちら',
            link: registerUrl,
            question: '',
            isShowBtn: !isLogin,
            target: true,
            dataLayer: {
                event: 'uaEvent',
                event_name: 'ecocredits_button',
                type: 'Register',
                list_name,
                button_name: '会員登録はこちら',
            },
        },
        {
            icon: <Icon2 />,
            title: 'ニュースレターに登録',
            subtitle: 'ニュースレターに登録すると500ポイント獲得',
            desc: '※ 会員登録の後にニュースレターに登録した場合のみ対象です。\n※ 本特典は登録後すぐにお客様のアカウントに付与されます。',
            linkText: 'ニュースレター登録',
            link: '',
            question: '',
            isShowBtn: true,
            onClick: () => {
                setShowModal(true);
            },
            dataLayer: {
                event: 'uaEvent',
                event_name: 'ecocredits_button',
                type: 'Join',
                list_name,
                button_name: 'ニュースレター登録',
            },
        },
        {
            icon: <Icon3 />,
            title: 'プロフィール作成',
            subtitle: 'プロフィールを作成すると1,000ポイント獲得',
            desc: '※ 本特典はプロフィール作成完了後すぐにお客様のアカウントに付与されます。',
            linkText: 'プロフィールを作成',
            link: !isLogin ? loginUrl : '/jp/my',
            question: '',
            isShowBtn: true,
            target: true,
            dataLayer: {
                event: 'uaEvent',
                event_name: 'ecocredits_button',
                type: 'Login',
                list_name,
                button_name: 'プロフィールを作成',
            },
        },
        {
            icon: <Icon4 />,
            title: 'LINE登録',
            subtitle: '4月8日（月）～4月14日（日）にLINE＆友だち登録すると500ポイント獲得！',
            desc: '※ 本特典は4月23日（火）までにお客様のアカウントに付与されます。',
            linkText: 'LINE登録',
            link: 'https://lin.ee/Hq6cIaE',
            question: '',
            isShowBtn: true,
            dataLayer: {
                event: 'uaEvent',
                event_name: 'offical_line_join',
                button_name: 'LINE登録',
                url: 'https://lin.ee/Hq6cIaE',
            },
        },
        {
            icon: <Icon5 />,
            title: 'X(Twitter)で投稿をシェア',
            subtitle:
                '4月8日（月）～4月14日（日）にEcoFlow会員に関する内容をXで投稿すると、抽選で50名様に500ポイントをプレゼント！詳しくは公式アカウント\n@EcoFlowJapanをご覧ください。',
            desc: '※ 本特典は4月23日（火）までにお客様のアカウントに付与されます。',
            linkText: 'Xでシェアする',
            link: 'https://twitter.com/EcoflowJapan',
            question: '',
            isShowBtn: true,
            dataLayer: {
                event: 'uaEvent',
                event_name: 'ecocredits_button',
                type: 'Other',
                list_name,
                button_name: 'Xでシェアする',
            },
        },
    ];

    React.useEffect(() => {
        setIsLogin(getIsLogin());
    }, []);

    return (
        <>
            <div className={styled.HowGet}>
                {list.map((item, i) => (
                    <div className="get_item" key={item.title}>
                        {item.icon}
                        <div className="title">
                            {item.title}
                            {i > 0 && (
                                <Popover overlayClassName="memberdays-dropDownIcon" content={<>{item.desc}</>} placement="top">
                                    <div className="title-icon">
                                        <QuesIcon />
                                    </div>
                                </Popover>
                            )}
                        </div>
                        <p className="subtitle">{item.subtitle}</p>
                        {i === 0 && item.desc && <p className="desc">{item.desc}</p>}
                        {item.isShowBtn && (
                            <EditorLink
                                className="link"
                                href={item.link}
                                target={item.target ? '_self' : '_blank'}
                                onClick={() => {
                                    item.onClick && item.onClick();
                                    // 是登陆或者注册页面
                                    if (item?.link?.includes?.('/login') || item?.link?.includes?.('/register')) {
                                        signupCookie?.({
                                            sector_name:
                                                '2024年、エコポイントプログラムがさらにバージョンアップ！最高の特典をお届けします' + '_' + item.linkText,
                                            entry_position: 5,
                                        });
                                    }
                                }}
                                dataLayer={item.dataLayer || {}}
                            >
                                {item.linkText} &gt;
                            </EditorLink>
                        )}
                    </div>
                ))}
            </div>
            {showModal && createPortal(<SignupPopup setVisible={setShowModal} />, document.body)}
        </>
    );
};

export default HowGet;
